import React, { useState, useEffect, useContext, createContext } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';

const AuthContext = createContext(undefined);

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user_type: null,
    access_token: '',
    id: null,
    first_name: null,
    last_name: null,
    email: null,
    profile_image: null,
  });
  const [loading, setLoading] = useState(true);

  // Set up axios header whenever auth changes
  useEffect(() => {
    if (auth.access_token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${auth.access_token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [auth.access_token]);

  useEffect(() => {
    const access_token = Cookies.get('access_token');
    const user_type = Cookies.get('user_type');
    const first_name = Cookies.get('first_name');
    const last_name = Cookies.get('last_name');
    const email = Cookies.get('email');
    const profile_image = Cookies.get('profile_image');

    if (access_token) {
      setAuth(prevAuth => ({
        ...prevAuth,
        access_token,
        user_type,
        first_name,
        last_name,
        email,
        profile_image,
      }));
    }
    setLoading(false);
  }, []);

  return <AuthContext.Provider value={[auth, setAuth, loading]}>{children}</AuthContext.Provider>;
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export { useAuth, AuthProvider };
